// 벡터 관련 유틸리티 함수들
class VectorUtils {
  // Three.js Vector3를 일반 객체로 변환
  static vector3ToObject(vector3) {
    return {
      x: vector3.x,
      y: vector3.y,
      z: vector3.z,
    };
  }

  // 일반 객체를 Three.js Vector3로 변환
  static objectToVector3(obj) {
    return new THREE.Vector3(obj.x, obj.y || 0, obj.z);
  }

  // 방향 벡터 계산
  static getDirection(from, to) {
    return new THREE.Vector3().subVectors(to, from).normalize();
  }

  // 목표 방향으로 회전
  static lookAtDirection(currentRotation, direction, rotationSpeed = 0.1) {
    if (direction.length() > 0) {
      const targetRotation = Math.atan2(direction.x, direction.z);
      const rotationDifference = MathUtils.normalizeRotationDifference(
        targetRotation - currentRotation
      );
      return currentRotation + rotationDifference * rotationSpeed;
    }
    return currentRotation;
  }

  // 즉시 목표 방향으로 회전
  static lookAtDirectionImmediate(currentRotation, direction) {
    if (direction.length() > 0) {
      return Math.atan2(direction.x, direction.z);
    }
    return currentRotation;
  }

  // 플레이어 전방 벡터 계산
  static getPlayerForwardVector(rotationY) {
    return new THREE.Vector3(
      Math.sin(rotationY),
      0,
      Math.cos(rotationY)
    ).normalize();
  }

  // 랜덤 위치 생성 (원형 영역 내)
  static getRandomPositionInCircle(center, minRadius, maxRadius) {
    const angle = Math.random() * Math.PI * 2;
    const distance = MathUtils.randomBetween(minRadius, maxRadius);

    return new THREE.Vector3(
      center.x + Math.cos(angle) * distance,
      center.y,
      center.z + Math.sin(angle) * distance
    );
  }

  // 카메라 경계 계산
  static getCameraBounds(cameraPosition, viewSize, margin = 0) {
    return {
      left: cameraPosition.x - viewSize - margin,
      right: cameraPosition.x + viewSize + margin,
      top: cameraPosition.z - viewSize - margin,
      bottom: cameraPosition.z + viewSize + margin,
    };
  }

  // 카메라 밖인지 확인
  static isOutsideCamera(position, cameraBounds) {
    return (
      position.x < cameraBounds.left ||
      position.x > cameraBounds.right ||
      position.z < cameraBounds.top ||
      position.z > cameraBounds.bottom
    );
  }
}

// webpack 빌드를 위해 default export 추가
export default VectorUtils;

// 전역 변수로도 등록 (기존 코드 호환성)
window.VectorUtils = VectorUtils;